export default {
  title: 'Confirmation dialog',
  content: 'Do you really want to delete a device in the lot?',
  confirm: 'Confirm',
  no: 'No',
};
